import { BaseComponent } from '../models/components/BaseComponent';
import { CloneService } from '../services/clone.service';

export function getComponentsWithout<T>(withoutType: string, components: Array<BaseComponent>) {
    const cloneService = new CloneService();
    let arr = new Array<BaseComponent>();
    for (let index = 0; index < components.length; index++) {
        const element = components[index];
        if (element.componentType == withoutType)
            continue;
        arr.push(element);
    }
    return cloneService.deepClone(arr);
}